import script from "./ShowPosterPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShowPosterPage.vue?vue&type=script&setup=true&lang=ts"

import "./ShowPosterPage.vue?vue&type=style&index=0&id=0adf3982&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0adf3982"]])

export default __exports__